/**
 * Breadcrumb.js
 * Breadcrumb navigation component
 */

import React from 'react';
import { Breadcrumb as BootstrapBreadcrumb } from 'react-bootstrap';
import { useLocation, Link } from 'react-router-dom';
import { getBreadcrumbConfig } from '../../helpers/breadcrumbHelper';

const Breadcrumb = () => {
  const location = useLocation();
  const breadcrumbs = getBreadcrumbConfig(location.pathname);

  // Don't show breadcrumb on dashboard or login pages
  if (!breadcrumbs || breadcrumbs.length === 0) {
    return null;
  }

  return (
    <BootstrapBreadcrumb className="mb-3">
      <BootstrapBreadcrumb.Item 
        linkAs={Link} 
        linkProps={{ to: '/dashboard' }}
      >
        <i className="fas fa-home me-1"></i>
        Home
      </BootstrapBreadcrumb.Item>
      
      {breadcrumbs.map((crumb, index) => {
        const isLast = index === breadcrumbs.length - 1;
        
        if (isLast) {
          return (
            <BootstrapBreadcrumb.Item key={index} active>
              {crumb.icon && <i className={`${crumb.icon} me-1`}></i>}
              {crumb.label}
            </BootstrapBreadcrumb.Item>
          );
        }
        
        return (
          <BootstrapBreadcrumb.Item 
            key={index}
            linkAs={Link}
            linkProps={{ to: crumb.path }}
          >
            {crumb.icon && <i className={`${crumb.icon} me-1`}></i>}
            {crumb.label}
          </BootstrapBreadcrumb.Item>
        );
      })}
    </BootstrapBreadcrumb>
  );
};

export default Breadcrumb;
